import { Badge } from "@/components/ui/badge";

const PRIORITY = {
  Hot: "bg-rose-500/10 text-rose-600 border-rose-200",
  Warm: "bg-amber-500/10 text-amber-600 border-amber-200",
  Cold: "bg-sky-500/10 text-sky-600 border-sky-200",
};

const STATUS = {
  New: "bg-slate-500/10 text-slate-600 border-slate-200",
  Contacted: "bg-indigo-500/10 text-indigo-600 border-indigo-200",
  "Mela Attended": "bg-violet-500/10 text-violet-600 border-violet-200",
  "Docs Submitted": "bg-cyan-500/10 text-cyan-600 border-cyan-200",
  "Application Created": "bg-amber-500/10 text-amber-600 border-amber-200",
  Approved: "bg-emerald-500/10 text-emerald-600 border-emerald-200",
  Disbursed: "bg-blue-500/10 text-blue-600 border-blue-200",
};

export const PriorityPill = ({ value }) => (
  <Badge variant="outline" className={`${PRIORITY[value] || PRIORITY.Warm} font-semibold`} data-testid={`priority-pill-${value}`}>
    {value}
  </Badge>
);

export const StatusPill = ({ value }) => (
  <Badge variant="outline" className={`${STATUS[value] || STATUS.New} font-semibold`} data-testid={`status-pill`}>
    {value}
  </Badge>
);
